<template>
  <div class="d-flex flex-column w-100">
    <div
      v-for="variationAttribute in variationAttributes"
      :key="variationAttribute.attribute.propertyId"
      class="fs-property d-flex mb-3 variations"
    >
      <div class="headline text-uppercase">
        <span>{{ variationAttribute.attribute.texts[lang] }}</span>
      </div>

      <mh-variation-image-selection
        v-if="variationAttribute.attribute.type === 'images'"
        :variation-id="variationId"
        :variation-attributes="decode(variationAttribute.value.values.value)"
        :preload-image-limit="preloadImageLimit"
        :lang="lang"
      />
      <mh-variation-dropdown-selection
        v-else-if="variationAttribute.attribute.type === 'dropdown'"
        :variation-id="variationId"
        :variation-attributes="decode(variationAttribute.value.values.value)"
        :lang="lang"
      />
      <mh-variation-textbox-selection
        v-else-if="variationAttribute.attribute.type === 'textbox'"
        :variation-id="variationId"
        :variation-attributes="decode(variationAttribute.value.values.value)"
        :lang="lang"
      />
    </div>
  </div>
</template>

<script>

import VariationImageSelection from './VariationImageSelection.vue'
import VariationDropdownSelection from './VariationDropdownSelection.vue'
import VariationTextboxSelection from './VariationTextboxSelection.vue'

export default {
    name: 'MhVariationSelection',
    components: {
        MhVariationImageSelection: VariationImageSelection,
        MhVariationDropdownSelection: VariationDropdownSelection,
        MhVariationTextboxSelection: VariationTextboxSelection
    },
    props: {
        variationId: {
            type: Number,
            required: true
        },
        variationProperties: {
            type: Array,
            default: () => []
        },
        preloadImageLimit: {
            type: Number,
            default: 12
        }
    },
    computed: {
        validAttributes () {
            return App.modeherzConfig.itemVariations.reduce((agg, cur) => ({ [cur.propertyId]: cur, ...agg }), {})
        },
        lang () {
            return App.language
        },
        variationAttributes () {
            if (!this.variationProperties) {
                return []
            }
            return this.variationProperties
                .flatMap(vp => vp.properties)
                .filter(p => !!this.validAttributes[p.id])
                .map(p => ({ attribute: this.validAttributes[p.id], value: p }))
                .sort((a, b) => {
                    const aPrio = a.attribute.priority
                    const bPrio = b.attribute.priority
                    return aPrio - bPrio
                })
        }
    },
    methods: {
        decode (value) {
            if (value) {
                return JSON.parse(value).data.items
            }
            return []
        }
    }
}
</script>
